import React from "react";
import {MedicationAttribute} from "../../types";

export interface MedicationCardAttributesProps {
    medicationIntake: string;
    attributes: MedicationAttribute[];
}

const MedicationCardAttributes = ({medicationIntake, attributes}: MedicationCardAttributesProps) => {
    const generateMedicationIntake = () => {
        return (
            <pui-section fullWidth spacingBottom="med-small">
                <pui-text class="medication-intake" input={medicationIntake} textSize="medium" fontWeight="bold"></pui-text>
            </pui-section>
        )
    }

    const generateMedicationAttributes = () => {
        return (
            <pui-section class="medication-attributes" flowDirection="vertical" mainaxisarrangement="center" fullWidth>
                {attributes.map(attribute => {
                    return (!!attribute.key && !!attribute.value) ?
                        (
                            <pui-section spacingBottom="small" key={attribute.key} id={attribute.key} flowDirection="horizontal" fullWidth>
                                <pui-text input={attribute.key} textSize='medium' textColor="grey"></pui-text>
                                <pui-text input={attribute.value} textAlign="right" textSize='medium'></pui-text>
                            </pui-section>
                        ) :
                        <></>
                })}
            </pui-section>
        )
    }

    return (
        <pui-section class="list-attributes" flowDirection='vertical' fullWidth>
            {medicationIntake && generateMedicationIntake()}
            {generateMedicationAttributes()}
        </pui-section>
    );
}
export default MedicationCardAttributes;
